import { CardMembership, OpenInFull } from '@mui/icons-material';
import { Button, IconButton, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { Fragment, useMemo } from 'react';

import { formatShortDate } from '@jebel/utils';

import { useMediaPreview, useModalState, useResponsive } from 'shared/hooks';

import { MembershipLogo, UserMembershipCard, UserMembershipCardProps } from '../UserMembershipCard';
import { MembershipFullScreenModal } from './UserMembershipsListItem.styles';

export function UserMembershipsListItem({ user, status, membership }: UserMembershipCardProps) {
  const {
    show: showMembershipModal,
    open: openMembershipModal,
    close: closeMembershipModal,
  } = useModalState();

  const { isMobile } = useResponsive();
  const { src, srcSet } = useMediaPreview(membership.logo);

  const memberSinceDate = useMemo(() => {
    return formatShortDate(membership.creationDate);
  }, [membership.creationDate]);

  return (
    <Fragment>
      <ListItem
        onClick={openMembershipModal}
        secondaryAction={
          isMobile ? (
            <IconButton>
              <OpenInFull fontSize="small" />
            </IconButton>
          ) : (
            <Button startIcon={<OpenInFull fontSize="small" />}>Open</Button>
          )
        }
      >
        <ListItemAvatar>
          <MembershipLogo src={src} srcSet={srcSet} membershipColor={membership.color}>
            <CardMembership fontSize="inherit" />
          </MembershipLogo>
        </ListItemAvatar>

        <ListItemText primary={membership.name} secondary={`Member since: ${memberSinceDate}`} />
      </ListItem>

      <MembershipFullScreenModal open={showMembershipModal} onClose={closeMembershipModal}>
        <UserMembershipCard user={user} status={status} membership={membership} />
      </MembershipFullScreenModal>
    </Fragment>
  );
}
